import moment from 'moment';

const getTotalPrice = (
  rentalItem,
  startingDate,
  endTime,
  startTime,
  multiDates,
  availableUnits,
  addOns,
  currency
) => {
  let total = 0;
  const pricesType = rentalItem?.pricesType;

  if (pricesType === 'pricesDailyForm') {
    total = calculateDailyPriceTotal(
      rentalItem,
      multiDates,
      availableUnits,
      currency
    );
  } else if (pricesType === 'pricesFixedForm') {
    total = calculateFixedPriceTotal(
      rentalItem,
      availableUnits,
      currency,
      multiDates
    );
  } else if (pricesType === 'pricesWeeklyForm') {
    total = calculateWeeklyPriceTotal(
      rentalItem,
      multiDates,
      availableUnits,
      currency
    );
  } else if (pricesType === 'pricesHourlyForm'){
    total = calculateHourlyPriceTotal(
      rentalItem,
      startingDate,
      endTime,
      startTime,
      availableUnits,
      currency
    )
  }


  if (addOns) {
    addOns.map(item => {
      if (!item.value || !parseInt(item.value)) return;
      total += parseInt(item.value) * item[currency];
    });
  }

  return parseFloat(total.toFixed(2));
};


const calculateDailyPriceTotal = (rentalItem, multiDates, availableUnits, currency) => {
  if (!rentalItem?.pricesDailyForm?.days || !availableUnits || availableUnits.length === 0) {
    return 0;
  }

  
  const firstUnit = availableUnits[0];
  if (firstUnit?.currencyValue && firstUnit.currency === currency) {
    return firstUnit.currencyValue * parseInt(firstUnit.availableUnits || '0');
  }

 
  const selectedDays = getDaysBetweenDates(multiDates.startDate, multiDates.endDate);
  let dailyTotal = 0;

  selectedDays.forEach(dayName => {
    const dayAbbreviation = dayName.substring(0, 3); 
    const dayPrice = rentalItem.pricesDailyForm.days.find(d => 
      d.day.toLowerCase() === dayAbbreviation.toLowerCase()
    );
    
    if (dayPrice && dayPrice[currency] && !isNaN(parseFloat(dayPrice[currency]))) {
      dailyTotal += parseFloat(dayPrice[currency]);
    }
  });

  return dailyTotal * parseInt(availableUnits[0]?.availableUnits || '0');
};


const calculateFixedPriceTotal = (rentalItem, availableUnits, currency, multiDates) => {
  if (!rentalItem?.pricesFixedForm || !availableUnits || availableUnits.length === 0) {
    return 0;
  }

  const price = parseFloat(rentalItem.pricesFixedForm[currency] || 0);
  if (isNaN(price) || price <= 0) return 0;

  
  const units = parseInt(availableUnits[0]?.availableUnits || '0');


  let totalDays = 1;
  if (multiDates?.startDate && multiDates?.endDate) {
    const start = moment(multiDates.startDate);
   
    
    const end = moment(multiDates.endDate);
   
    
    totalDays = end.diff(start, 'days') + 1; 
  }
  const total = price * units * totalDays;

  return total;
};



const calculateWeeklyPriceTotal = (rentalItem, multiDates, availableUnits, currency) => {
  if (!rentalItem?.pricesWeeklyForm?.weekList || !availableUnits || availableUnits.length === 0) {
    return 0;
  }

  const firstUnit = availableUnits[0];
  if (firstUnit?.currencyValue && firstUnit.currency === currency) {
    return firstUnit.currencyValue * parseInt(firstUnit.availableUnits || '0');
  }


  const selectedDays = getDaysBetweenDates(multiDates.startDate, multiDates.endDate);
  let weeklyTotal = 0;

  rentalItem.pricesWeeklyForm.weekList.forEach(weekItem => {
    const daysInCategory = selectedDays.filter(day => 
      weekItem.days.includes(day)
    ).length;
    
    if (daysInCategory > 0 && weekItem[currency] && !isNaN(parseFloat(weekItem[currency]))) {
      weeklyTotal += parseFloat(weekItem[currency]) * daysInCategory;
    }
  });

  return weeklyTotal * parseInt(availableUnits[0]?.availableUnits || '0');
};

const calculateHourlyPriceTotal = (rentalItem, startingDate, endTime, startTime, availableUnits, currency) => {
  if (!availableUnits || availableUnits.length === 0) {
    return 0;
  }

  const firstUnit = availableUnits[0];
  
  let hourlyTotal = 0;
  if (firstUnit?.breakdown && Array.isArray(firstUnit.breakdown)) {
    firstUnit.breakdown.forEach(hourSlot => {
      if (hourSlot.currency === currency && hourSlot.value) {
        hourlyTotal += parseFloat(hourSlot.value);
      }
    });
  }

  return hourlyTotal * parseInt(firstUnit?.availableUnits || '0');
};

const getDaysBetweenDates = (startDate, endDate) => {
  if (!startDate || !endDate) return [];
  
  const days = [];
  let currentDate = moment(startDate);
  const end = moment(endDate);

  while (currentDate.isSameOrBefore(end, 'day')) {
    days.push(currentDate.format('dddd')); 
    currentDate.add(1, 'day');
  }

  return days;
};

export {getTotalPrice};